import { styled } from 'styled-components';

import { Loader } from './loader';
import { StyledGridContainer } from './no-results-overlay';

export function PageLoader({ copy }: { copy?: string }) {
  return (
    <StyledGridContainer>
      <Loader size='3x' variant='grey' />
      {copy && (
        <StyledRegularText aria-busy='true' role='alert'>
          {copy}
        </StyledRegularText>
      )}
    </StyledGridContainer>
  );
}

const StyledRegularText = styled.span`
  font: var(--font-regular-14pt-normal);
  color: var(--color-greyscale-grey-40);
  margin-top: var(--sizes-60);
`;
